.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.list {
  position: relative;
  display: flex;
  gap: var(--space-1);
  overflow-x: auto;
  border-block-end: var(--border-width) solid var(--color-border);
  scrollbar-width: none;
}

.tab {
  display: inline-flex;
  align-items: center;
  block-size: var(--control-lg);
  padding-inline: var(--space-3);
  color: var(--color-text-muted);
  font-size: var(--text-md);
  font-weight: var(--weight-medium);
  white-space: nowrap;
  cursor: default;
}

@media (hover: hover) and (pointer: fine) {
  .tab:hover:not([data-disabled]) {
    color: var(--color-text);
  }
}

.tab[data-active] {
  color: var(--color-text);
}

.tab[data-disabled] {
  color: var(--color-text-subtle);
}

.tab:focus-visible {
  outline-offset: calc(var(--focus-ring-width) * -1);
}

/* Tab switches are frequent, so the indicator moves without animation (motion restraint). */
.indicator {
  position: absolute;
  inset-block-end: calc(var(--border-width) * -1);
  inset-inline-start: var(--active-tab-left);
  inline-size: var(--active-tab-width);
  block-size: var(--focus-ring-width);
  background: var(--color-accent);
}

.panel {
  outline: 0;
}
